<template>
    <section>
        <div>
            <form @submit.prevent="findAccount" novalidate>    
            <div class="t-body3 mgt-6 t-color-content1" v-html="$t('384', {str: `<strong class='t-color-title'>${findPw.step3.value}</strong>`})">
                <!-- <span class="bold">{{findPw.step3.value}}</span>로 전송된 <span class="bold t-color-red1">코드6자리</span>를 입력하시면
                비밀번호를 재설정하실 수 있습니다. -->
            </div>
            <div class="mgt-38">
                <div class="mdc-text-field mdc-text-field--outlined w-full"
                    :class="submitState && certiNumberInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="certiNumberEl"
                >
                    <input type="number" class="mdc-text-field__input"
                        id="certiNumber"
                        name="certiNumber"
                        v-model="certiNumber"
                        v-validate="'required|numeric|length:6'"
                        ref="certiNumber"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('385')}}                        
                            <!-- 6자리의 코드 입력 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23">
                    <span v-show="submitState && certiNumberInvalidCheck">
                        {{$t('956')}}
                        <!-- 전송된 인증번호 6자리를 입력해주세요. -->
                    </span>
                </div>
            </div>
            <div class="mgt-38">
                <button class="mdc-button mdc-button--raised btn-red">
                    {{$t('386')}}
                    <!-- 다음 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelFindPw()" type="button">
                    {{$t('387')}}
                    <!-- 취소 -->
                </button>
            </div>
            </form>

            <div class="mgt-30 t-body4 t-color-gray1">
                <a @click="showMessage(1)">
                    {{$t('388')}}
                    <!-- 코드를 받지 못하셨나요? -->
                </a>
                {{$t('389')}}
                <!-- 혹은 -->
                <a @click="showMessage(2)">
                    {{$t('390')}}
                    <!-- 사용할 수 없는 번호인가요? -->
                </a>
            </div>
        </div>
    </section>

    
</template>

<script>
/**
 * 비밀번호 재설정 Step3 컴포넌트 (reset password Step3 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {findPwMixin} from '@/mixins/findPw.js'

export default {
    data() {
        return {
            certiNumber: '',
            certiNumberTextField: null,
            submitState: false
        }
    },

    mixins: [findPwMixin],

    computed: {
        ...mapState('findPw',{
            findPw : state => state,
        }),

        // 인증번호 유효성 체크(validation check certiNumber)
        certiNumberInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('certiNumber')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }

            this.certiNumberTextField.valid === !returnValue ? '' : this.certiNumberTextField.valid = !returnValue
            return returnValue
        }
    },

    mounted() {
        // 토큰값이 없을 경우 Step1로 이동(If there is no token value, go to Step1)
        if (!this.findPw.step3.token) {
            this.$moveLogin()
        }
        this.setMaterialUi()
        this.$refs.certiNumber.focus()
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('findPw', ['SET_STEP3','SET_AUTHSTATE']),

        setMaterialUi() {
            this.certiNumberTextField = new MDCTextField(document.querySelector('#certiNumberEl'))
            this.certiNumberTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        // 인증번호 발송 API 호출(Authentication number sending API call)
        getReCertiNumber() {
            
            let params = this.findPw.step2
            let responseData = null

            // set certi number
            findApi.requestFindPw(params).then((response) => {
                responseData = response.data.data
                this.SET_STEP3({
                    value: this.findPw.step2.value,
                    token: responseData.token
                })

                this.$router.push({
                    name: 'FindPwStep3'
                })
            }).catch((err) => {
                responseData = err.response.data.meta
                this.$error({content: responseData.errMsg}).then(() => {})
            })
        },

        // 비밀번호 재설정위한 인증번호 확인(check certiNumber)
        findAccount() {

            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {

                    let params = {
                        token: this.findPw.step3.token,
                        value: this.certiNumber
                    }

                    let responseData = null
                    findApi.checkFindPw(params).then((response) => {
                        responseData = response.data.data

                        this.SET_AUTHSTATE({
                            authState: responseData,
                            certiNumber: this.certiNumber
                        })

                        if (responseData) {
                            this.$router.push({
                                name: 'FindPwStep4', 
                            })
                        }else {
                            // this.$snackOpen({contents:'코드를 잘못 입력하셨습니다. <br>전송된 코드 6자리를 확인 후 다시 시도해주세요.'}).then(() => {})
                            this.$snackOpen({
                                contents: this.$t('424') +' '+ this.$t('425'),
                                btnDisplayYN: false
                                }).then(() => {})
                        }
                        

                    }).catch((err) => {
                        responseData = err.response.data.meta
                        // this.errorModal({content: responseData.errMsg}).then(() => {})
                        // this.$snackOpen({contents:'코드를 잘못 입력하셨습니다. <br>전송된 코드 6자리를 확인 후 다시 시도해주세요.'}).then(() => {})
                        this.$snackOpen({
                            contents: this.$t('424') +' '+ this.$t('425'),
                            btnDisplayYN: false
                            }).then(() => {})

                        this.$refs.certiNumber.focus()
                    })
                    
                }else {
                    this.$refs.certiNumber.focus()
                }
            })
        }
    },
}
</script>